




























































import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { Extra, ExtraVariation } from '@/api';

@Component({
  components: {},
})
export default class extends Vue {
  @Model('input', { type: Array })
  readonly value: Extra[];

  @Prop({ required: true }) readonly extraVariations: ExtraVariation[];
  @Prop({ required: true }) readonly items: Extra[];

  loading: boolean = false;

  get selected() {
    if (!this.value) {
      return [];
    }
    return this.value.map(element => element.id);
  }

  set selected(itemArray) {
    this.$emit(
      'input',
      this.items.filter(item => itemArray.includes(item.id)),
    );
  }

  get hasUnavailable() {
    if (!this.items) {
      return false;
    }
    return this.items.some(e => !e.available);
  }

  extrasByType(type: string) {
    return this.items.filter(i => i.extraType === type);
  }

  extraPrice(item: Extra) {
    const variant = this.extraVariations.find(
      (variation: ExtraVariation) => variation.extra.id === item.id,
    );
    if (variant && variant.price) {
      return variant.formattedPrice;
    } else {
      return item.formattedPrice;
    }
  }
}
